import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { JsonApiResponse } from '../../shared/models/JsonApiResponse';
import { environment } from '../../../environments/environment';
import { MessageRecipientCollectionModel } from '../../pages/live-map/models/message-recipient-collection.model';
import { SendMessageModel } from '../../pages/live-map/models/send-message.model';
import { MessageModel } from '../../pages/live-map/models/message.model';
import {HttpErrorHandler} from '../../http.error.handler';
import { firstValueFrom } from 'rxjs';
import { MultiSelectFilter } from '../../shared/components/multi-select-component';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor(private http: HttpClient) {
  }

  getRecipients(): Promise<JsonApiResponse<MessageRecipientCollectionModel>> {
    const endpointUrl = `${environment.services.service}v1/messaging/recipients`;
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<MessageRecipientCollectionModel>>(endpointUrl, {})
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  getMessages(
    dateFrom: Moment,
    dateTo: Moment,
    driverFilter: MultiSelectFilter<number> = null,
    authorEmails: MultiSelectFilter<string> = null,
  ): Promise<JsonApiResponse<MessageModel[]>> {
    let params = new HttpParams();
    if (dateFrom) {
      params = params.set('dateFrom', dateFrom.toISOString());
    }
    if (dateTo) {
      params = params.set('dateTo', dateTo.toISOString());
    }
    if (driverFilter?.elements) {
      params = params.set('driverIds', driverFilter.elements.join(':::'));
    }
    if (authorEmails?.elements) {
      params = params.set('authorEmails', authorEmails.elements.join(':::'));
    }
    const endpointUrl = `${environment.services.service}v1/messaging/list`;
    return firstValueFrom(
      this.http
        .get<JsonApiResponse<MessageModel[]>>(
          endpointUrl,
          {params},
        )
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  sendMessage(sendMessageDto: SendMessageModel): Promise<JsonApiResponse<MessageModel>> {
    const endpointUrl = `${environment.services.service}v1/messaging/send`;
    return firstValueFrom(
      this.http
        .post<JsonApiResponse<MessageModel>>(endpointUrl, sendMessageDto)
        .pipe(
          catchError(HttpErrorHandler.handleError)
        )
    );
  }

  deleteMessage(messageId: number) {
    const requestUrl = `${environment.services.service}v1/messaging/${messageId}/delete`;
    return firstValueFrom(
      this.http
        .delete<void>(requestUrl)
        .pipe(
            catchError(HttpErrorHandler.handleError)
        )
    );
  }
}
